enum AssignmentTrackerTranslationVariant {
    pageTitle = 'pageTitle'
    , backToLessonPlanner = 'backToLessonPlanner'
    , tableTitle = 'tableTitle'
    , classroomFilter = 'classroomFilter'
    , studentFilter = 'studentFilter'
    , title = 'title'
    , dateAssigned = 'dateAssigned'
    , dateDue = 'dateDue'
    , assignedTo = 'assignedTo'
    , assignmentStatus = 'assignmentStatus'
    , assignedStudents = 'assignedStudents'
    , messages = 'messages'
    , newMessage = 'newMessage'
    , noNewMessages = 'noNewMessages'
    , noMessages = 'noMessages'
    , audioMessage = 'audioMessage'
    , educatorMessage = 'educatorMessage'
    , studentName = 'studentName'
    , attemptStatus = 'attemptStatus'
    , attemptFiles = 'attemptFiles'
    , noAttemptFiles = 'noAttemptFiles'
    , files = 'files'
    , activity = 'activity'
    , activityType = 'activityType'
    , activityTypeClickAway = 'activityTypeClickAway'
    , activityTypeCustomContent = 'activityTypeCustomContent'
    , activityTypeWorkbook = 'activityTypeWorkbook'
    , workbook = 'workbook'
    , workbookPage = 'workbookPage'
    , allOption = 'allOption'
    , none = 'none'
    , titleNoData = 'titleNoData'
    , subTitleNoData = 'subTitleNoData'
    , buttonTitleNoData = 'buttonTitleNoData'
    , studentTitleNoData = 'studentTitleNoData'
    , send = 'send'
    , back = 'back'

}

export default AssignmentTrackerTranslationVariant;